// extracted by mini-css-extract-plugin
export default {"Wrapper":"vtrg_video_Wrapper__ptnbl","Preloader":"vtrg_video_Preloader__AGaM+"};